<template>
    <a href="javascript:void(0);"
        data-toggle="popover"
        title="Verfügbare Sonderangebote"
        data-trigger="click"
        data-placement="top"
        data-html="true"
        :data-content="getOfferText()"
        tabindex="-1">
        <img class="offer-img"
            src="https://r.v-office.com/preview/v1962/1717494321000/img/offers.svg"
            width="40"
            height="40"
            aria-label="Angebote anzeigen">
    </a>
</template>

<script>
    import V from 'voUtils/V.js';
    import DateEx from 'voUtils/DateEx.js';

    import {
    	getVoucher
    }
    from 'voUtils/VoucherStore.js';

    export default {
    	voVueComponent: 'offer-help',
    	props: {
    		offers: Array
    	},

    	mounted: function() {

    		$('[data-toggle="tooltip"]').tooltip();

    		$('[data-toggle="popover"]').popover({
    			html: true,
    			trigger: 'click',
    			placement: 'top',
    			container: 'body'
    		});

    		// Popover schließen wenn außerhalb geklickt wird
    		$('body').on('click', function(e) {
    			$('[data-toggle="popover"]').each(function() {
    				if (!$(this).is(e.target) &&
    					$(this).has(e.target).length === 0 &&
    					$('.popover').has(e.target).length === 0
    				) {
    					$(this).popover('hide');
    				}
    			});
    		});
    	},

    	methods: {

    		getVoucherCode: function() {
    			var voucher = getVoucher();
    			if (voucher) {
    				return voucher.code;
    			}
    			return null;
    		},

    		getOfferText: function() {

    			var offerText = '';
    			var cur = VOFFICE.currency || '&euro;';

    			if (this.offers) {

    				const sortedOffers = [...this.offers].sort((a, b) =>
    					(a.fromdate > b.fromdate) ? 1 : -1
    				);

    				for (let i = 0; i < sortedOffers.length; i++) {

    					var offer = sortedOffers[i];

    					if (!offer.voucherCode || offer.voucherCode === this.getVoucherCode()) {

    						offerText += '<li><a href="./s#?offerid=' + offer.id + '">';

    						offerText += offer.name + " ";

    						if (offer.discountType === 'PERCENT') {
    							offerText += "- " + offer.value / 100 + "% " + this.voMsg('tpl.text.rabatt') + " ";
    						}

    						if (offer.discountType === 'FLAT') {
    							offerText += "- " + offer.value / 100 + " " + cur + " " + this.voMsg('tpl.text.rabatt') + " ";
    						}

    						if (offer.type === 'EARLYBIRD') {
    							if (offer.timeSpan === 1) {
    								offerText += this.voMsg('tpl.offer.earlybird.arrival') + " ";
    							} else if (offer.timeSpan > 1) {
    								offerText += this.voMsg('tpl.offer.earlybird.arrival.pl') + " " + offer.timeSpan + " " + this.voMsg('tpl.offer.earlybird.days') + " ";
    							}
    						}

    						if (offer.type === 'LASTMINUTE') {
    							if (offer.timeSpan == 1) {
    								offerText += this.voMsg('tpl.search.offer.lastminute.arrival') + " ";
    							} else if (offer.timeSpan > 1) {
    								offerText += this.voMsg('tpl.search.offer.lastminute.arrival.pl') + " " + offer.timeSpan + " " + this.voMsg('tpl.text.days') + " ";
    							}
    						}

    						if (offer.fromdate) {
    							offerText += this.voMsg('tpl.text.from') + " " +
    								DateEx.formatDate(offer.fromdate, undefined, VOFFICE.mlang) + " ";
    						}

    						if (offer.tilldate) {
    							offerText += this.voMsg('tpl.text.until') + " " +
    								DateEx.formatDate(offer.tilldate, undefined, VOFFICE.mlang) + " ";
    						}

    						if (offer.minStay > 1) {
    							offerText += "(" + this.voMsg('tpl.min') + " " +
    								offer.minStay + " " + this.voMsg('tpl.text.nights') + ")";
    						}

    						offerText += "</a></li>";
    					}
    				}
    			}

    			return '<ul>' + offerText + '</ul>';
    		}
    	}
    };
</script>